function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useState } from 'react';
import { Box, Text, IconButton, Menu, Pressable, Flex, useTheme } from 'native-base';
import HandlePost from './HandlePost';
import { Alert, Platform } from 'react-native';
import { useAuthState } from '../../../context/auth';
import FRNMenu from './reusables/FRNMenu';
import ChangeTopicCategory from '../../moderator/ChangeTopicCategory';
import MovePost from '../../moderator/MovePost';
import { moderatorAPI, useModeratorDispatch } from '../../../context/moderator';
import { topicsAPI, useTopicsDispatch } from '../../../context/topics';
import Confirm from '../../content/common/reusables/Confirm';
import { getFutureDate, checkFlagged } from '../../utils/helpers';
import FlagPost from '../flagPost/FlagPost';
import FlaggedAlready from '../flagPost/FlaggedAlready';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { faShareNodes } from '@fortawesome/pro-solid-svg-icons';
import { faTrashCan } from '@fortawesome/pro-solid-svg-icons';
import { faRightLeft } from '@fortawesome/pro-solid-svg-icons';
import { faShuffle } from '@fortawesome/pro-solid-svg-icons';
import { faThumbtack } from '@fortawesome/pro-solid-svg-icons';
import { faEllipsis } from '@fortawesome/pro-solid-svg-icons';
import { faCircleXmark } from '@fortawesome/pro-solid-svg-icons';
import { useEnvState } from '../../../context/env';
import { LANGUAGES } from '../../Constants';
import { useEditPostDispatch } from '../../../context/edit';
const MoreActions = ({
  reply,
  topic,
  updateTopicPost,
  updateTopicReplies,
  forSingleTopicScreen,
  navigation,
  loadContents,
  updateForceReloadTopics,
  trackForum
}) => {
  const theme = useTheme(),
    {
      colors
    } = theme;
  const authState = useAuthState();
  const topicsDispatch = useTopicsDispatch();
  const envState = useEnvState();
  const {
    platform_user_id,
    api_key,
    moderator
  } = authState;
  const type = topic ? 'topic' : 'reply';
  const wasTopicPinnedBeforeAPICall = type === 'topic' && topic.pinned;
  const isPostFlagged = checkFlagged(reply);
  const DELETED_RAW_HTML = '<p>(Post deleted by user.)</p>';
  const replyIsDeleted = reply.raw == DELETED_RAW_HTML;
  const checkIsTopicYours = () => {
    if (type === 'topic' && topic && topic.first && topic.first.post && topic.first.post.username) {
      const {
        username
      } = topic.first.post;
      if (username === 'system') {
        return false;
      }
      if (username.split('.')[1].toString() === platform_user_id.toString()) {
        return true;
      }
    }
    return false;
  };
  const isTopicYours = checkIsTopicYours();
  const isReplyYours = type === 'reply' && reply.yours;

  /* dataId is solely for testing environment; should be removed when going live
   * The Menu.Group below titled "User Actions" was once `${type}: ${dataId}` */
  const dataId = type === 'reply' ? 'reply-' + reply.id.toString() : 'topic-' + topic.id.toString();

  /*
  This is the value required for "until" field when pinning a topic
  10 years from the moment of function call in the format of 'YYYY-MM-DD'
  */
  const futureDate = getFutureDate();
  const moderatorDispatch = useModeratorDispatch();

  // for changing topic category and moving reply
  const [showModal, setShowModal] = useState(false);

  // for marking topic as spam
  const [showFlagModal, setShowFlagModal] = useState(false);
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const onOpenHandler = () => {
    setMenuIsOpen(true);
  };
  const onCloseHandler = () => {
    setMenuIsOpen(false);
  };
  const editPostDispatch = useEditPostDispatch();
  const handleAlert = itemType => {
    const onConfirmYes = async () => {
      let deleteSucceeded;
      if (itemType === 'topic') {
        if (topic.posts_count > 1) {
          let firstReplyId = topic !== null && topic !== void 0 && topic.first && topic !== null && topic !== void 0 && topic.first.post ? topic === null || topic === void 0 ? void 0 : topic.first.post.id : reply === null || reply === void 0 ? void 0 : reply.id;
          deleteSucceeded = await topicsAPI.updateReply(envState.base_url, api_key, firstReplyId, {
            raw: DELETED_RAW_HTML
          });
        } else {
          deleteSucceeded = await topicsAPI.deleteTopic(envState.base_url, api_key, topic === null || topic === void 0 ? void 0 : topic.id);
        }
      } else {
        deleteSucceeded = await topicsAPI.deleteReply(envState.base_url, api_key, reply === null || reply === void 0 ? void 0 : reply.id);
      }
      if (deleteSucceeded) {
        // call updateTopicReplies() for deleted reply
        if (itemType === 'reply') {
          if (updateTopicReplies) {
            updateTopicReplies(reply.topic_id);
            editPostDispatch({
              type: 'SET_POST_UPDATED',
              payload: {
                topicId: topic === null || topic === void 0 ? void 0 : topic.id
              }
            });
          }
        }
        // force reload of topics
        topicsDispatch({
          type: 'SET_FORCE_RELOAD_TOPICS',
          payload: true
        });
        if (itemType === 'topic' && forSingleTopicScreen) {
          navigation.goBack();
        }
        loadContents && loadContents();
      }
    };
    const acceptedTypes = ['topic', 'reply'];
    if (!acceptedTypes.includes(itemType)) {
      throw new Error('Invalid type');
    }
    const title = 'Confirm';
    const message = LANGUAGES.CONFIRM_DECISION;
    const buttons = [{
      text: 'Yes',
      onPress: onConfirmYes
    }, {
      text: 'Cancel',
      style: 'cancel'
    }];
    if (Platform.OS === 'web') {
      return Confirm.confirm(title, message, buttons, onConfirmYes);
    } else {
      return Alert.alert(title, message, buttons);
    }
  };
  const handleDeleteTopicReply = () => {
    try {
      if (type === 'topic') {
        handleDeleteTopic();
      } else {
        handleDeleteReply();
      }
      return true;
    } catch (err) {
      console.log('Error while deleting the post');
      return false;
    }
  };
  const handleDeleteTopic = async () => {
    /* can't use reply.can_delete here because Discourse won't allow you to hard delete a topic
     * we want a soft delete in some cases so have to use this custom logic instead */
    if (!isTopicYours && !moderator) {
      // this should never show up as Delete button can be seen only by original posters
      console.log(LANGUAGES.HANDLE_DELETE_POST_MESSAGE);
      return false;
    }
    handleAlert('topic');
    return true;
  };
  const handleDeleteReply = async () => {
    if (!reply.can_delete) {
      // this should never show up as Delete button can be seen only by original posters
      console.log(LANGUAGES.HANDLE_DELETE_POST_MESSAGE);
      return false;
    }
    handleAlert('reply');
    return true;
  };
  const updateTopicCategory = async (topicID, destinationCategoryID) => {
    try {
      moderatorDispatch({
        type: 'GET_INITIAL'
      });
      const data = {
        category_id: destinationCategoryID
      };
      const response = await topicsAPI.updateTopic(envState.base_url, api_key, topicID, data);
      const {
        id,
        title
      } = response === null || response === void 0 ? void 0 : response.basic_topic;
      moderatorDispatch({
        type: 'SET_TOPIC_ID_WITH_NEW_CATEGORY_HOME',
        payload: id
      });
      return response;
    } catch (err) {
      console.log('Error while updating topic category');
      return {};
    }
  };
  const movePostToAnotherTopic = async (currentTopicID, replyID, destinationTopicID) => {
    try {
      moderatorDispatch({
        type: 'GET_INITIAL'
      });
      const data = {
        post_ids: [replyID],
        destination_topic_id: destinationTopicID
      };
      const response = await moderatorAPI.movePostToAnotherTopic(envState.base_url, currentTopicID, api_key, data);
      if (!response) {
        throw new Error('An error occurred while moving the reply.');
      }
      updateTopicReplies && updateTopicReplies(currentTopicID);
      moderatorDispatch({
        type: 'SET_MOVE_REPLY_DESTINATION_TOPIC_ID',
        payload: destinationTopicID
      });
      return response;
    } catch (err) {
      console.log('Error while moving post to another topic');
      return {};
    }
  };
  const handlePinTopic = () => {
    moderatorDispatch({
      type: 'SET_PINNED_TOPIC_ID',
      payload: null
    });
    moderatorDispatch({
      type: 'SET_UNPINNED_TOPIC_ID',
      payload: null
    });
    const title = 'Confirm';
    let message = wasTopicPinnedBeforeAPICall ? `Would you like to unpin the topic: "${topic.title}"?` : `Would you like to pin this topic: "${topic.title}"?`;
    const onConfirmYes = async () => {
      try {
        const data = wasTopicPinnedBeforeAPICall ? {
          status: 'pinned',
          enabled: 'false',
          until: null
        } : {
          status: 'pinned',
          enabled: 'true',
          until: futureDate // this field is required; using random value for now
        };
        const response = await moderatorAPI.updateTopicStatus(envState.base_url, topic === null || topic === void 0 ? void 0 : topic.id, api_key, data);
        if (!response || response.success !== 'OK') {
          throw new Error('Could not un/pin the topic.');
        } else {
          if (wasTopicPinnedBeforeAPICall) {
            moderatorDispatch({
              type: 'SET_UNPINNED_TOPIC_ID',
              payload: topic === null || topic === void 0 ? void 0 : topic.id
            });
          } else {
            moderatorDispatch({
              type: 'SET_PINNED_TOPIC_ID',
              payload: topic === null || topic === void 0 ? void 0 : topic.id
            });
          }
          if (forSingleTopicScreen) {
            updateForceReloadTopics && updateForceReloadTopics();
          } else {
            updateTopicReplies && updateTopicReplies(topic === null || topic === void 0 ? void 0 : topic.id);
          }
        }
        return response;
      } catch (err) {
        console.log('Error while pinning/unpinning topic');
        return Alert.alert('Error', 'Could not handle request to un/pin the topic.');
      }
    };
    const buttons = [{
      text: 'Yes',
      onPress: onConfirmYes
    }, {
      text: 'Cancel',
      style: 'cancel'
    }];
    if (Platform.OS === 'web') {
      return Confirm.confirm(title, message, buttons, onConfirmYes);
    } else {
      return Alert.alert(title, message, buttons);
    }
  };
  const handleUrlCopy = () => {
    const id = type === 'topic' ? topic === null || topic === void 0 ? void 0 : topic.id : reply === null || reply === void 0 ? void 0 : reply.id;
    const baseUrl = window.location.origin + window.location.pathname.replace(/\/$/, '');
    const hash = '/#!';
    const typeId = `/${type}/` + id;
    const uniqueUrl = `${baseUrl}${hash}${typeId}`;
    if (Platform.OS === 'web') {
      navigator.clipboard.writeText(uniqueUrl);
      return Confirm.alert(uniqueUrl + ' copied to clipboard');
    } else {
      return Alert.alert(uniqueUrl + ' copied to clipboard');
    }
  };
  return /*#__PURE__*/React.createElement(Box, null, moderator && showModal && type === 'topic' && /*#__PURE__*/React.createElement(ChangeTopicCategory, {
    topic: topic,
    showModal: showModal,
    setShowModal: setShowModal,
    updateTopicCategory: updateTopicCategory
  }), moderator && showModal && type === 'reply' && /*#__PURE__*/React.createElement(MovePost, {
    reply: reply,
    showModal: showModal,
    setShowModal: setShowModal,
    movePostToAnotherTopic: movePostToAnotherTopic
  }), showFlagModal && type === 'reply' && !isPostFlagged ? /*#__PURE__*/React.createElement(FlagPost, {
    type: type,
    topic: topic,
    reply: reply,
    showFlagModal: showFlagModal,
    setShowFlagModal: setShowFlagModal,
    updateTopicReplies: updateTopicReplies
  }) : /*#__PURE__*/React.createElement(FlaggedAlready, {
    showFlagModal: showFlagModal,
    setShowFlagModal: setShowFlagModal
  }), /*#__PURE__*/React.createElement(FRNMenu, {
    closeOnSelect: true,
    isOpen: menuIsOpen,
    onOpen: onOpenHandler,
    onClose: onCloseHandler,
    justifyContent: 'center',
    trigger: triggerProps => {
      return /*#__PURE__*/React.createElement(Pressable, null, /*#__PURE__*/React.createElement(IconButton, _extends({
        p: 0
      }, triggerProps, {
        icon: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
          icon: faEllipsis
        })
      })));
    }
  }, /*#__PURE__*/React.createElement(Menu.Group, {
    title: 'User Actions'
  }, /*#__PURE__*/React.createElement(Menu.Item, {
    onPress: onCloseHandler
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: 'row',
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faCircleXmark
  }), " ", /*#__PURE__*/React.createElement(Text, null, "Close"))), type === 'reply' && /*#__PURE__*/React.createElement(Menu.Item, {
    onPress: () => setShowFlagModal(true)
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: 'row',
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faXmark
  }), " ", /*#__PURE__*/React.createElement(Text, null, "Flag post"))), /*#__PURE__*/React.createElement(Menu.Item, {
    onPress: handleUrlCopy
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: 'row',
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faShareNodes
  }), " ", /*#__PURE__*/React.createElement(Text, null, "Share"))), !replyIsDeleted && (isTopicYours || isReplyYours || moderator) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Menu.Item, null, /*#__PURE__*/React.createElement(HandlePost, {
    updateTopicPost: updateTopicPost,
    updateTopicReplies: updateTopicReplies,
    type: type,
    topic: topic,
    reply: reply,
    edit: true,
    onCloseHandler: onCloseHandler,
    trackForum: trackForum
  })), /*#__PURE__*/React.createElement(Menu.Item, {
    onPress: handleDeleteTopicReply
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: 'row',
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faTrashCan,
    color: colors.moreActions.delete
  }), ' ', /*#__PURE__*/React.createElement(Text, {
    color: colors.moreActions.delete
  }, "Delete"))))), moderator && /*#__PURE__*/React.createElement(Menu.Group, {
    title: 'Moderator',
    bg: colors.moreActions.moderator.bg
  }, type === 'topic' && /*#__PURE__*/React.createElement(Menu.Item, {
    onPress: () => setShowModal(true)
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: 'row',
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faRightLeft,
    color: colors.moreActions.change
  }), " ", /*#__PURE__*/React.createElement(Text, null, "Change category"))), type === 'reply' && /*#__PURE__*/React.createElement(Menu.Item, {
    onPress: () => setShowModal(true)
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: 'row',
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faShuffle
  }), " ", /*#__PURE__*/React.createElement(Text, null, "Move post"))), type === 'topic' && /*#__PURE__*/React.createElement(Menu.Item, {
    onPress: handlePinTopic
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: 'row',
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faThumbtack,
    color: colors.moreActions.pin
  }), ' ', /*#__PURE__*/React.createElement(Text, null, wasTopicPinnedBeforeAPICall ? 'Unpin topic' : 'Pin topic'))))));
};
export default MoreActions;
//# sourceMappingURL=MoreActions.js.map